const isScreenZoomed = () => {
  const isHighDPI = window.devicePixelRatio > 1;
  const browserZoomLevel = Math.round(window.devicePixelRatio * 100);
  if (isHighDPI && browserZoomLevel > 200) return true;
  if (!isHighDPI && browserZoomLevel > 100) return true;
  return false;
};
export {
  isScreenZoomed
};
//# sourceMappingURL=isScreenZoomed.js.map
